var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlotiqBadgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275 276",
    style: {
      enableBackground: "new 0 0 275 276"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0083FC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,37.6C0,16.9,16.8,0,37.5,0H100c4.4,0,8.6,0.8,12.5,2.2c18.9,6.7,36.2,22.9,56.2,22.9S206,8.9,224.9,2.2 C228.8,0.8,233,0,237.4,0C258.2,0,275,16.9,275,37.6s-16.8,37.6-37.5,37.6c-4.4,0-8.6-0.8-12.5-2.2c-18.9-6.7-36.2-22.9-56.2-22.9 S131.5,66.3,112.6,73c-3.9,1.4-8.1,2.2-12.5,2.2H37.5C16.8,75.3,0,58.4,0,37.6z M0,138c0-20.8,16.8-37.6,37.5-37.6 c5.5,0,10.7,1.2,15.4,3.3c16.5,7.5,32,21.8,50.2,21.8c18.1,0,33.7-14.3,50.2-21.8c4.7-2.1,9.9-3.3,15.4-3.3 c20.7,0,37.5,16.8,37.5,37.6s-16.8,37.6-37.5,37.6c-5.5,0-10.7-1.2-15.4-3.3c-16.5-7.5-32-21.8-50.2-21.8 c-18.1,0-33.7,14.3-50.2,21.8c-4.7,2.1-9.9,3.3-15.4,3.3C16.8,175.6,0,158.8,0,138z M37.5,200.7C16.8,200.7,0,217.6,0,238.4 S16.8,276,37.5,276S75,259.1,75,238.4S58.2,200.7,37.5,200.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlotiqBadgeLogo);
export default __webpack_public_path__ + "static/media/flotiq_badge-logo.098dcc36d263f8e8836f45e9f485cb7a.svg";
export { ForwardRef as ReactComponent };